// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar .nav-link[data-v-37377dfa]:hover{color:inherit;background-color:transparent!important}.doctorsidebar[data-v-37377dfa]{max-height:100vh;overflow-y:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
